module.exports = __webpack_public_path__ + "files/11282c7d44c40424e97b9767d481118b.png";